import { createSectionFactory } from "@hydrologiq/shared/createSection"
import { Section } from "@hydrologiq/shared/providers/CopyProvider"
import Routing from "@hydrologiq/planner/Routing"
import defaultCopy from "./copy"
import { graphqlUri, graphqlUriLegacy, graphqlUriPrimary, restEndpoint } from "./config"

// Create the section using the generic factory
const createSection = createSectionFactory({
  sectionName: "planner",
  section: Section.PLANNER,
  RoutingComponent: Routing,
  defaultCopy,
  graphqlUri,
  restEndpoint,
  primaryGraphqlUri: graphqlUriPrimary,
  legacyGraphqlUri: graphqlUriLegacy,
})

export default createSection
